module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_hozon-70fa0539a9eaa9183d07e17e932f798c.png";